import React, { useMemo, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { runAppeeSuite } from '../tests/appeeSuite';
import './TestSuite.css';

export default function TestSuite() {
  const navigate = useNavigate();
  const [nonce, setNonce] = useState(0);
  const result = useMemo(() => runAppeeSuite(), [nonce]);
  const rerun = useCallback(() => setNonce(n => n + 1), []);

  const { cats, passed, total, ms, allGreen } = result;
  const failing = cats.filter(c => !c.ok);

  return (
    <div className="ts-root">
      <div className="ts-panel">
        <header className="ts-head">
          <div className="ts-title">
            Appee — tests de non-régression{' '}
            <span className={allGreen ? 'ts-score ts-score-ok' : 'ts-score ts-score-ko'}>{passed}/{total}</span>
            <span className="ts-ms">{ms} ms</span>
          </div>
          <div className="ts-actions">
            <button className="ts-btn ts-btn-ghost" onClick={rerun}>↻ Relancer</button>
            <button className="ts-btn" onClick={() => navigate('/dashboard')}>Fermer</button>
          </div>
        </header>

        <div className="ts-chips">
          {cats.map(c => (
            <span key={c.key} className={`ts-chip ${c.ok ? 'ts-chip-ok' : 'ts-chip-ko'}`}>
              {c.label} <b>{c.passed}/{c.total}</b>
            </span>
          ))}
        </div>

        {failing.map(c => (
          <div key={c.key} className="ts-box ts-box-ko">
            <div className="ts-box-title">● {c.label} — {c.total - c.passed} échec(s)</div>
            {c.cases.filter(x => !x.pass).map((x, i) => (
              <div key={i} className="ts-fail">
                <span className="ts-fail-name">{x.name}</span>
                <span className="ts-fail-diff">
                  obtenu <code>{fmt(x.got)}</code> · attendu <code>{fmt(x.want)}</code>
                </span>
              </div>
            ))}
          </div>
        ))}

        {allGreen && (
          <div className="ts-box ts-box-ok">
            <div className="ts-box-title">● Tout passe.</div>
            <div className="ts-box-sub">
              Chaque brique critique (dates, SMS au segment, doublons, consentement nLPD,
              insights, marge par client) se comporte comme prévu. Aucune régression détectée.
            </div>
          </div>
        )}

        <footer className="ts-foot">
          {cats.length} catégories · {total} cas · lance-le après chaque déploiement pour repérer une régression en un coup d’œil.
        </footer>
      </div>
    </div>
  );
}

function fmt(v) {
  if (v === null) return 'null';
  if (v === undefined) return 'undefined';
  if (typeof v === 'string') return v.length > 40 ? v.slice(0, 40) + '…' : v;
  try { return JSON.stringify(v); } catch { return String(v); }
}
